const seatCharacteristic = [
    ['F', 'Added seat'],
    ['EX', 'No seat - emergency Exit'],
    ['G', 'Seat at forward end of cabin'],
    ['FC', 'Front of cabin class/compartment'],
    ['H', 'Seat with facilities for handicapped/incapacitated passenger'],
    ['GR', 'Group seat - offered to travellers belonging to a group'],
    ['IA', 'Inside aisle seats'],
    ['I', 'Seat suitable for adult with an infant'],
    ['J', 'Rear facing seat'],
    ['IE', 'Seat not suitable for child'],
    ['KA', 'Bulkhead seat with movie screen'],
    ['K', 'Bulkhead seat'],
    ['L', 'Leg space seat'],
    ['LH', 'Restricted seat - offered on long-haul segments'],
    ['LS', 'Left side of aircraft'],
    ['M', 'Seat without a movie view'],
    ['MA', 'Medically OK to travel'],
    ['N', 'No smoking seat'],
    ['O', 'Preferential seat'],
    ['OW', 'Overwing seats'],
    ['PC', 'Pet cabin'],
    ['Q', 'Seat in a quiet zone'],
    ['RS', 'Right side of aircraft'],
    ['S', 'Smoking seat'],
    ['T', 'Rear/Tail section of aircraft'],
    ['V', 'Seat to be left vacant or offered last'],
    ['UP', 'Upper deck'],
    ['U', 'Seat suitable for unaccompanied minors'],
    ['Z', 'Buffer zone seat'],
    ['X', 'No facility seat indifferent seat'],
    ['WA', 'Window and aisle together'],
    ['W', 'Window seat'],
    ['CS', 'Conditional seat-contact airline'],
    ['DE', 'Deportee'],
    ['EA', 'Not on exit seat'],
    ['E', 'Exit row seat'],
    ['EK', 'Economy comfort seat'],
    ['EC', 'Electronic connection for lap top or FAX machine'],
    ['AW', 'All available window seats'],
    ['AV', 'Only available seats'],
    ['B', 'Seat with bassinet facility'],
    ['C', 'Crew seat'],
    ['BK', 'Blocked Seat for preferred passenger in adjacent seat'],
    ['CH', 'Chargeable seats'],
    ['CC', 'Center section seats'],
    ['AG', 'Seat adjacent to galley'],
    ['AJ', 'Adjacent aisle seats'],
    ['AL', 'Seat adjacent to lavatory'],
    ['AM', 'Individual movie screen - No choice of movie selection'],
    ['AS', 'Individual airphone'],
    ['AT', 'Seat adjacent to table'],
    ['AU', 'Seat adjacent to stairs to upper deck'],
    ['7A', 'In front of toilet seat'],
    ['7B', 'Behind toilet seat'],
    ['8', 'No seat at this location'],
    ['9', 'Center seat not window, not aisle'],
    ['A', 'Aisle seat'],
    ['AA', 'All available aisle seats'],
    ['AB', 'Seat adjacent to bar'],
    ['AC', 'Seat adjacent to - closet'],
    ['6A', 'In front of galley seat'],
    ['6', 'Near galley seat'],
    ['5', 'Not an aisle seat'],
    ['4', 'Not a window seat'],
    ['7', 'Near toilet seat'],
    ['6B', 'Behind galley seat'],
    ['26', 'Seat designated for RBD \\W\\'],
    ['25', 'Seat designated for RBD \\V\\'],
    ['24', 'Seat designated for RBD \\T\\'],
    ['23', 'Seat designated for RBD \\S\\'],
    ['3B', 'Individual video screen-Choice of movies, games, information, etc'],
    ['3A', 'Individual video screen - No choice of movie'],
    ['3', 'Individual video screen - Choice of movies'],
    ['27', 'Seat designated for RBD \\Y\\'],
    ['1M', 'Seat with movie view'],
    ['1W', 'Window seat without window'],
    ['1C', 'Seat not allowed for unaccompanied minor'],
    ['1D', 'Restricted recline seat'],
    ['21', 'Seat designated for RBD \\Q\\'],
    ['22', 'Seat designated for RBD \\R\\'],
    ['2', 'Leg rest available'],
    ['20', 'Seat designated for RBD \\P\\'],
    ['16', 'Seat designated for RBD \\J\\'],
    ['17', 'Seat designated for RBD \\K\\'],
    ['14', 'Seat designated for RBD \\F\\'],
    ['15', 'Seat designated for RBD \\H\\'],
    ['1A', 'Seat not allowed for infant'],
    ['1B', 'Seat not allowed for medical'],
    ['18', 'Seat designated for RBD \\L\\'],
    ['19', 'Seat designated for RBD \\M\\'],
    ['11', 'Seat designated for RBD \\B\\'],
    ['10', 'Seat designated for RBD \\A\\'],
    ['13', 'Seat designated for RBD \\D\\'],
    ['12', 'Seat designated for RBD \\C\\'],
    ['1', 'Restricted seat - General'],
    ['1A_AQC_PREMIUM_SEAT', 'Premium seat'],
];

export default seatCharacteristic;



// WEBPACK FOOTER //
// ./src/app/modules/flights/flight-seatmap/seat-characteristics.js